import { useState, useEffect } from "react";
import { IconMenu2, IconX } from "@tabler/icons-react";
import { cn } from "@/lib/utils";

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Fecha o menu mobile quando a tela aumentar
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setIsMobileMenuOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Previne scroll quando menu mobile está aberto
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isMobileMenuOpen]);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <header
        className={cn(
          "fixed top-0 left-0 right-0 z-50 transition-all duration-300",
          "bg-white/95 backdrop-blur-md shadow-sm border-b border-slate-200"
        )}
      >
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
          <div className="flex items-center justify-between h-16 sm:h-20">
            {/* Logo */}
            <a href="#" className="flex items-center gap-2 sm:gap-3" aria-label="Ir para a página inicial da BRLD">
              <img
                src="/images/logo-brld.svg"
                alt="BRLD Logo"
                className="h-8 sm:h-10 w-auto"
              />
              <span className="text-lg sm:text-xl font-semibold text-slate-900">stableBRLD</span>
            </a>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center gap-1 lg:gap-2" aria-label="Navegação principal">
              <button
                onClick={() => scrollToSection("o-que-e")}
                className="px-3 lg:px-4 py-2 text-sm font-medium text-slate-700 rounded-lg hover:bg-slate-100 transition-colors"
              >
                O que é BRLD
              </button>
              <button
                onClick={() => scrollToSection("pilares")}
                className="px-3 lg:px-4 py-2 text-sm font-medium text-slate-700 rounded-lg hover:bg-slate-100 transition-colors"
              >
                Casos de uso
              </button>
              <button
                onClick={() => scrollToSection("seguranca")}
                className="px-3 lg:px-4 py-2 text-sm font-medium text-slate-700 rounded-lg hover:bg-slate-100 transition-colors"
              >
                Segurança
              </button>
              <button
                onClick={() => scrollToSection("faq")}
                className="px-3 lg:px-4 py-2 text-sm font-medium text-slate-700 rounded-lg hover:bg-slate-100 transition-colors"
              >
                FAQ
              </button>
              <a
                href="/login"
                className="ml-1 lg:ml-2 inline-flex items-center justify-center rounded-lg border-2 border-[#0038B5] bg-transparent px-4 lg:px-6 py-2 lg:py-2.5 text-sm font-medium text-[#0038B5] hover:bg-[#0038B5]/5 transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#0038B5] whitespace-nowrap"
              >
                Acessar Plataforma BRLD
              </a>
            </nav>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden p-2 -mr-2 rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-slate-900"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Abrir ou fechar menu de navegação"
              aria-expanded={isMobileMenuOpen}
            >
              {isMobileMenuOpen ? (
                <IconX className="w-6 h-6 text-slate-900" strokeWidth={2} />
              ) : (
                <IconMenu2 className="w-6 h-6 text-slate-900" strokeWidth={2} />
              )}
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu - FORA do header para evitar o containing block do backdrop-filter */}
      {isMobileMenuOpen && (
        <div
          className="md:hidden fixed inset-x-0 top-16 sm:top-20 bottom-0 bg-white z-[60] overflow-y-auto border-t border-slate-200 shadow-lg"
          aria-label="Navegação principal mobile"
        >
          <nav className="flex flex-col p-4 space-y-1">
            <button
              onClick={() => scrollToSection("o-que-e")}
              className="text-left text-base font-medium text-slate-700 hover:text-[#0038B5] hover:bg-slate-50 transition-colors py-3 px-4 rounded-lg"
            >
              O que é BRLD
            </button>
            <button
              onClick={() => scrollToSection("pilares")}
              className="text-left text-base font-medium text-slate-700 hover:text-[#0038B5] hover:bg-slate-50 transition-colors py-3 px-4 rounded-lg"
            >
              Casos de uso
            </button>
            <button
              onClick={() => scrollToSection("seguranca")}
              className="text-left text-base font-medium text-slate-700 hover:text-[#0038B5] hover:bg-slate-50 transition-colors py-3 px-4 rounded-lg"
            >
              Segurança
            </button>
            <button
              onClick={() => scrollToSection("faq")}
              className="text-left text-base font-medium text-slate-700 hover:text-[#0038B5] hover:bg-slate-50 transition-colors py-3 px-4 rounded-lg"
            >
              FAQ
            </button>
            <div className="pt-4 mt-2 border-t border-slate-200">
              <a
                href="/login"
                className="w-full inline-flex items-center justify-center rounded-lg bg-[#0038B5] px-6 py-3.5 text-base font-medium text-white hover:opacity-95 transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#0038B5]"
              >
                Acessar Plataforma BRLD
              </a>
            </div>
          </nav>
        </div>
      )}
    </>
  );
};

export default Header;
